<template>
    <div class="input-group searchToolBar">
        <div class="input-group-text border-0 pr-0 bg-grey-light2">
            <img
                v-lazy-load
                src="/nuxt-assets/images/lazy-load-error.svg"
                :data-src="`/nuxt-assets/images/icons/magnifier.svg`"
                width="15"
                height="16"
                alt="magnifier"
            />
        </div>
        <input
            v-model="searchQuery"
            class="form-control form-control-sm border-0 bg-grey-light2"
            type="text"
            :placeholder="$t('discussions.search')"
            @keyup="search()"
        />
        <div class="input-group-text border-0 bg-grey-light2">
            <button class="border-0 p-0 bg-grey-light2 cursor-point" @click="resetSearch">
                <img
                    v-lazy-load
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="`/nuxt-assets/images/icons/close.svg`"
                    alt="close"
                />
            </button>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    data() {
        return {
            searchQueries: [],
            searchQuery: '',
        }
    },

    methods: {
        search() {
            const searchQuery = this.searchQuery.toLowerCase().normalize('NFC')

            this.searchQueries = searchQuery.split(/ /g).filter((query: string) => query)
            useNuxtApp().$bus.$emit('searchQueries', this.searchQueries)
        },
        resetSearch() {
            this.searchQuery = ''
            this.search()
        },
    },
}
</script>

<style lang="scss" scoped>
.searchToolBar {
    max-width: 350px;

    @media (max-width: 768px) {
        margin-top: 10px;
    }
}
</style>
